import React from "react";
import RegionsMap from "@/components/RegionsMap";

function Arabesque({ id = "arabesque", color = "#B8860B" }) {
  return (
    <svg className="absolute inset-0 w-full h-full" aria-hidden="true">
      <defs>
        <pattern id={id} width="48" height="48" patternUnits="userSpaceOnUse">
          <g fill="none" stroke={color} strokeWidth="0.9" opacity="0.5">
            <rect x="10" y="10" width="28" height="28" />
            <rect x="10" y="10" width="28" height="28" transform="rotate(45 24 24)" />
            <circle cx="24" cy="24" r="4" />
            <path d="M0 24h10M38 24h10M24 0v10M24 38v10" />
          </g>
        </pattern>
        <radialGradient id={`${id}-fade`} cx="50%" cy="45%" r="70%">
          <stop offset="0%" stopColor="#F4ECDC" stopOpacity="0.2" />
          <stop offset="100%" stopColor="#F4ECDC" stopOpacity="0.95" />
        </radialGradient>
      </defs>
      <rect width="100%" height="100%" fill={`url(#${id})`} />
      <rect width="100%" height="100%" fill={`url(#${id}-fade)`} />
    </svg>
  );
}

/** Illustrated print cover: arabesque pattern, macro-regions map, title and the 23 flags. */
export default function EbookCover({ kicker, title, subtitle, note, countries = [], testid = "ebook-cover", accent = "#B8860B", children }) {
  return (
    <section className="relative min-h-[80vh] print:min-h-[95vh] rounded-3xl print:rounded-none border-[6px] border-double border-ochre/60 bg-sand overflow-hidden flex flex-col items-center justify-between text-center px-8 py-10 break-after-page" data-testid={testid}>
      <Arabesque color={accent} />
      <header className="relative z-10 space-y-3">
        <div className="text-[10px] uppercase tracking-[0.35em] text-ochre font-semibold">{kicker}</div>
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-display font-bold text-ink leading-[1.05] max-w-2xl" data-testid={`${testid}-title`}>{title}</h1>
        <div className="mx-auto w-16 h-[3px] bg-ochre rounded-full" />
        <p className="text-base md:text-lg text-ink/80 max-w-lg mx-auto" data-testid={`${testid}-subtitle`}>{subtitle}</p>
      </header>
      <div className="relative z-10 w-full max-w-md my-6 [&_svg]:drop-shadow-sm">
        {children || <RegionsMap countries={countries} active={null} onRegion={() => {}} onCountry={() => {}} />}
      </div>
      <footer className="relative z-10 space-y-4">
        <div className="flex flex-wrap justify-center gap-1.5 max-w-md mx-auto" data-testid={`${testid}-flags`}>
          {countries.map((c) => <img key={c.code} src={c.flag_url} alt="" className="w-8 h-[22px] object-cover rounded-sm border border-stoneLine shadow-sm" />)}
        </div>
        {note && <div className="text-xs text-muted-foreground">{note}</div>}
      </footer>
    </section>
  );
}
